/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* istanbul ignore file */
const React = require('react');
const { string, number, bool, shape, any, objectOf } = require('prop-types');
const { Element, scroller } = require('react-scroll');

const { useState, useEffect } = React;
const Image = require('nordic/image');
const Form = require('@andes/form');
const Card = require('@andes/card');
const Button = require('@andes/button');
const RadioButton = require('@andes/radio-button');

const { RadioGroup } = RadioButton;
const { useI18n } = require('../../../../utils/context/i18nContext');

const { sendSurvey, sendSurveyReason } = require('../../../../browserServices/effectivity');

const REBRANDING_THEME = 'yellowblue-light';

function Effectivity({ business, contentId, eventData, sourceId, device, theme }) {
  const [radioButtonsData, setRadioButtonsData] = useState([]);
  const [radioButtonsDataShuffled, setRadioButtonsDataShuffled] = useState(false);

  const isMPRebrandingTheme = theme === REBRANDING_THEME;

  const i18n = useI18n();

  const radioButtonsDataArray = [
    {
      id: 'eff-opt-1',
      name: 'option1',
      text: i18n.gettext('La información es confusa.'),
    },
    {
      id: 'eff-opt-2',
      name: 'option2',
      text: i18n.gettext('La solución que propone no funciona.'),
    },
    {
      id: 'eff-opt-3',
      name: 'option3',
      text: i18n.gettext('No estoy de acuerdo con la política.'),
    },
    {
      id: 'eff-opt-4',
      name: 'option4',
      text: i18n.gettext('Otro motivo.'),
    },
  ];

  const shuffleArray = array => {
    // eslint-disable-next-line no-plusplus
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  };
  useEffect(() => {
    shuffleArray(radioButtonsDataArray);
    setRadioButtonsData(radioButtonsDataArray);
    setRadioButtonsDataShuffled(true);
  }, [radioButtonsDataShuffled]);


  const [hasUserClickedNo, setHasUserClickedNo] = useState(false);
  const [isSurveyFinished, setIsSurveyFinished] = useState(false);
  const [voteId, setVoteId] = useState(null);
  const [checkedOption, setCheckedOption] = useState('');
  const [wrapperAnimationClassName, setWrapperAnimationClassName] = useState(null);

  const initialTitle = i18n.gettext('¿Te fue útil la información?');
  const secondTitle = i18n.gettext('Cuéntanos por qué no te fue útil la información:');

  const greetingText = i18n.gettext('¡Muchas gracias! Tu opinión ayuda a mejorar esta información para todas las personas.');

  const congratsImageML = 'https://http2.mlstatic.com/storage/cx-support-fcm-api/fcm-pub-os/cx-support-mario-frontend/josumendez/img-congrats-ml.png';
  const congratsImageMP = 'https://http2.mlstatic.com/storage/cx-support-fcm-api/fcm-pub-os/cx-support-mario-frontend/josumendez/img-congrats-mp.png';

  const buildDevicePlatform = ({ desktop, mobile, webView, osName }) => {
    const view = webView ? 'mobile' : 'web';
    let osNamePath = view === 'web' && desktop ? 'desktop' : 'mobile';
    if (view === 'mobile' && mobile) {
      osNamePath = osName;
    }
    return `/${view}/${osNamePath}`;
  };

  const sendUserSurvey = (value) => {
    const surveyValue = value;

    sendSurvey({
      origin: 'portal',
      source_id: sourceId,
      platform: buildDevicePlatform(device),
      has_channels: eventData.portal_has_channels_configured,
      content_id: contentId,
      value: surveyValue,
    }).then(response => {
      const elem = document.getElementsByName('greetingTextRef');
      if (elem.length > 0) elem[0].focus();
      if (response.status === 200 && window && window.melidata) {
        window.melidata('cleanAndSend', 'event', {
          path: '/portal/faq/effectivity_survey/click',
          event_data: {
            ...eventData,
            portal_effectivity_survey_value: surveyValue,
          },
        });
      }
      setVoteId(response?.data?.id);
    }).catch(error => {
      throw new Error(`API error: ${error.message}`);
    });
  };

  const answerYesOnclick = () => {
    sendUserSurvey(1);
    setIsSurveyFinished(true);
    setWrapperAnimationClassName('fade-up');
  };

  const answerNoOnclick = () => {
    sendUserSurvey(-1);
    setHasUserClickedNo(true);
    setWrapperAnimationClassName('expanded');
    scroller.scrollTo('scroll-to-element', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: (450 - window.innerHeight),
    });
  };

  const onSubmitSurvey = () => {
    setIsSurveyFinished(true);
    setWrapperAnimationClassName('fade-up');
    if (voteId != null) {
      sendSurveyReason({
        origin: 'portal',
        source_id: sourceId,
        platform: buildDevicePlatform(device),
        has_channels: eventData.portal_has_channels_configured,
        content_id: contentId,
        value: -1,
        id: voteId,
        reason: checkedOption,
      }).then(response => {
        const elem = document.getElementsByName('greetingTextRef');
        if (elem.length > 0) elem[0].focus();
        if (response.status === 200 && window && window.melidata) {
          window.melidata('cleanAndSend', 'event', {
            path: '/portal/faq/effectivity_survey/reason',
            event_data: {
              ...eventData,
              portal_effectivity_survey_reason: checkedOption,
            },
          });
        }
      }).catch(error => {
        throw new Error(`API error: ${error.message}`);
      });
    }
  };

  return (
    <Card className={`cx-peach__effectivity ${wrapperAnimationClassName}`}>
      {
        !isSurveyFinished && (
          <Element name="scroll-to-element" className={!hasUserClickedNo ? 'cx-peach__effectivity__wrapper' : 'cx-peach__effectivity__wrapper fade-in-out'}>
            <h2 className={!hasUserClickedNo ? 'cx-peach__effectivity__title' : 'cx-peach__effectivity__title mb-25'}>{ !hasUserClickedNo ? initialTitle : secondTitle }</h2>
              {!hasUserClickedNo && (
              <div className="cx-peach__effectivity__buttons">
                <Button
                  className="btn yes"
                  onClick={answerYesOnclick}
                  hierarchy="quiet"
                  size="medium"
                  data-testid="yes-btn"
                >
                  {i18n.gettext('Sí')}
                </Button>
                <Button
                  className="btn no"
                  onClick={answerNoOnclick}
                  hierarchy="quiet"
                  size="medium"
                  data-testid="no-btn"
                >
                  {i18n.gettext('No')}
                </Button>
              </div>
              )}
              {hasUserClickedNo && (
              <Form className="cx-peach__effectivity__survey" onSubmit={onSubmitSurvey}>
                <RadioGroup onChange={(e) => setCheckedOption(e.target.value)} name="effectivity">
                  {radioButtonsData.map((reason) => (
                    <RadioButton
                      key={reason.id}
                      id={reason.id}
                      name={reason.name}
                      value={reason.text}
                      label={reason.text}
                    />
                  ))}
                </RadioGroup>
                <Button
                  className="cx-peach__effectivity__submit"
                  disabled={checkedOption === ''}
                  hierarchy="loud"
                  size="large"
                  type="submit"
                  data-testid="submit-btn"
                >
                  {i18n.gettext('Enviar')}
                </Button>
              </Form>
              )}
          </Element>
        )
      }
      {isSurveyFinished && (
        <div className="cx-peach__effectivity__congrats slide-up">
          <h3 name="greetingTextRef" tabIndex="0">{greetingText}</h3>
          <figure>
            <Image src={business === 'ML' || isMPRebrandingTheme ? congratsImageML : congratsImageMP} alt="" lazyload="off" />
          </figure>
        </div>
      )}
    </Card>
  );
}

Effectivity.propTypes = {
  business: string.isRequired,
  contentId: number.isRequired,
  eventData: shape({
    portal_content_id: number,
    portal_has_channels_configured: bool,
  }).isRequired,
  sourceId: number.isRequired,
  device: objectOf(any).isRequired,
};

module.exports = Effectivity;
